module.exports = "<p>\r\n  clipart works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/gallery/clipart/clipart.component.html
// module id = ./src/app/components/gallery/clipart/clipart.component.html
// module chunks = main